import {
    GET_JOB_OFFER_ALERTS,
    GET_JOB_OFFER_ALERTS_SUCCESS,
    DELETE_JOB_OFFER_ALERT,
    DELETE_JOB_OFFER_ALERT_SUCCESS,
    TOGGLE_JOB_OFFER_ALERT,
    TOGGLE_JOB_OFFER_ALERT_SUCCESS,
    CREATE_JOB_OFFER_ALERT,
    CREATE_JOB_OFFER_ALERT_SUCCESS
} from '../action-types'

export const getJobOfferAlerts = (token) => ({
    type: GET_JOB_OFFER_ALERTS,
    token
})

export const getJobOfferAlertsSuccess = (data) => ({
    type: GET_JOB_OFFER_ALERTS_SUCCESS,
    data
})

export const deleteJobOfferAlert = (token, alertId, intl) => ({
    type: DELETE_JOB_OFFER_ALERT,
    token,
    alertId,
    intl
})

export const deleteJobOfferAlertSuccess = (alertId) => ({
    type: DELETE_JOB_OFFER_ALERT_SUCCESS,
    alertId
})

export const toggleJobOfferAlert = (token, alertId, intl) => ({
    type: TOGGLE_JOB_OFFER_ALERT,
    token,
    alertId,
    intl
})

export const toggleJobOfferAlertSuccess = (alertId) => ({
    type: TOGGLE_JOB_OFFER_ALERT_SUCCESS,
    alertId
})

export const createJobOfferAlert = (token, data, intl) => ({
    type: CREATE_JOB_OFFER_ALERT,
    token,
    data,
    intl
})

export const createJobOfferAlertSuccess = (data) => ({
    type: CREATE_JOB_OFFER_ALERT_SUCCESS,
    data
})
